import React from 'react';
import { Box, Stack } from '@atlaskit/primitives';
import { deleteContacts, DeleteButton } from './delete-invoice-contact.styles';
import { WarningDialog } from '../..';

export enum ContactType {
  CUSTOMER_CONTACT = 'customer contact',
  INVOICE_CONTACT = 'invoice contact',
}
interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
  contact: string;
  contactType: string;
  onDeleteConfirm: (_contact: string, _closeModal: () => void) => void;
  isLoading?: boolean;
}

export const DeleteContact = ({
  isModalOpen,
  closeModal,
  openModal,
  contact,
  onDeleteConfirm,
  contactType,
  isLoading,
}: Props) => {
  return (
    <Stack>
      <Box padding="space.200" xcss={deleteContacts}>
        <DeleteButton onClick={openModal}>Delete</DeleteButton>
      </Box>
      <WarningDialog
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={() => onDeleteConfirm(contact, closeModal)}
        header={`Delete ${contactType}`}
        description={<p>This will permanently delete the {contactType}. This can't be undone.</p>}
        okLabel={'Confirm'}
        testId={'delete-warning-confirm-modal'}
        isLoading={isLoading}
      />
    </Stack>
  );
};
